export default __webpack_public_path__ + "static/media/smile.78647336.svg";